export enum TabsIds {
    DEFAULT = 'DEFAULT',
    REALTORS = 'REALTORS',
    DEVELOPERS = 'DEVELOPERS',
}
